import type { Component, Entity2D } from '../../odie';
import type { GameScene } from '../GameScene';

import type { MysteryRewardId } from '../defs/reward';
import { BlockEntity } from '../entities/BlockEntity';
import { blockIterateAll } from '../util/blockTools';

/*
    tracks game state
*/
export class StateComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'state';

  // fields
  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // state
  private _rewards!: { [key in MysteryRewardId]?: number };

  public cageThrowsRemaining = 0;
  public parcelThrowsRemaining = 0;

  // impl
  //-------------------------------------------------------------------------
  public init(): void {
    // reset state
    this._rewards = {};
  }

  public onGameStart() {
    this.cageThrowsRemaining = this.countCageThrowsRemaining();
    this.parcelThrowsRemaining = this.countParcelThrowsRemaining();
  }

  // api
  //-------------------------------------------------------------------------
  // gifts
  public getReward(id: MysteryRewardId): number {
    return this._rewards[id] || 0;
  }

  public addReward(id: MysteryRewardId, block?: BlockEntity) {
    // increment gift count
    this._rewards[id] = this.getReward(id) + 1;

    // set modified
    this.entity.setModified(StateComponent, { rewards: true, id, block });
  }

  private countCageThrowsRemaining() {
    const remainingGoal = this.entity.c.map.goals.cage;
    let cagesInMap = 0;

    // Count cages in map
    blockIterateAll(this.entity.scene as GameScene, (base, overlay) => {
      // Cages are always in the overlay
      if (overlay?.c.block.blockId === 'cage') {
        cagesInMap += 1;
      }
    });

    return Math.max(0, remainingGoal - cagesInMap);
  }

  private countParcelThrowsRemaining() {
    const remainingGoal = this.entity.c.map.goals.hatAll;
    let parcelsInMap = 0;

    // Count parcels in map
    blockIterateAll(this.entity.scene as GameScene, (base) => {
      // Parcels are always in the base
      if (base?.c.block.blockId === 'hatAll') {
        parcelsInMap += 1;
      }
    });

    return Math.max(0, remainingGoal - parcelsInMap);
  }
}
